import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'alert',
  templateUrl: 'alert.html',
  styleUrls: ['alert.scss']
})
export class Alert {

  constructor(
    public dialogRef: MatDialogRef<Alert>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  onNoClick(): void {
    this.dialogRef.close(2);
  }

}
